import React from "react";
import { Alert, Snackbar } from "@mui/material";

export default function RecurringInvoiceToast({ toast, onClose }) {
    return (
        <Snackbar
            open={toast.open}
            autoHideDuration={4000}
            onClose={onClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        >
            <Alert onClose={onClose} severity={toast.severity} sx={{ width: "100%" }}>
                {toast.msg}
            </Alert>
        </Snackbar>
    );
}
